// extracted by mini-css-extract-plugin
var _1 = "_productManagementDiscountDetails-module__action-button-disabled";
var _2 = "_productManagementDiscountDetails-module__form-action-button-disabled";
var _3 = "_productManagementDiscountDetails-module__loader";
var _4 = "_productManagementDiscountDetails-module__subcontainer";
export { _1 as "action-button-disabled", _2 as "form-action-button-disabled", _3 as "loader", _4 as "subcontainer" }
